<template>
  <div class="proyecto-container" v-bind:class="classObject" @click="abrirUrl">
    <img class="proyecto-img" :src="require(`@/assets/img/${imgSrc}`)">
    <div class="proyecto-hover-container">
      <p class="proyecto-title">{{title}}</p>
      <p class="proyecto-body">{{body}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "proyecto",
  props: ["title", "body", "imgSrc", "url"],
  computed: {
    classObject: function() {
      return {
        "proyecto-container-active": this.url != null
      };
    }
  },
  methods: {
    abrirUrl: function() {
      if (this.url != null) window.location.href = this.url;
    }
  }
};
</script>

<style>
@import "../assets/css/proyecto.css";
</style>
